import React from "react";

export const ScrollCue = () => (
  <div
    className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/70 z-10"
    data-testid="scroll-cue"
  >
    <span className="text-[10px] tracking-luxe uppercase">Scroll</span>
    <div className="w-px h-10 bg-white/30 relative overflow-hidden">
      <div
        className="absolute top-0 left-0 w-full h-1/2 bg-white"
        style={{ animation: "scrollLine 2s ease-in-out infinite" }}
      />
    </div>
    <style>{`@keyframes scrollLine {0%{transform:translateY(-100%);}100%{transform:translateY(200%);}}`}</style>
  </div>
);

export default ScrollCue;
